/**
 * @module lib/text
 * Utilities for dealing with text.
 * TODO: this can probably be dissolved into lib/format and lib/validate.
 */


/**
 * Search for the given query text within the given content text
 * Performs a case-insensitive search
 *
 * @param {string} content the string to search through
 * @param {string} query the substring to search for
 * @returns {boolean}
 */
export function search(content, query) {
  return content.toLowerCase().includes(query.toLowerCase());
}

/**
 * Convert smart quotes to nnormal quotes in the given string
 *
 * @returns {string}
 */
export function convertSmartQuotes(inputString) {
  return inputString
    // replace smart single quotes
    .replace(/[\u2018\u2019]/g, "'")
    // replace smart double quotes
    .replace(/[\u201C\u201D]/g, '"');
}

/**
 * Check if the given string is able to be sent as a text message
 * The regex here is the same one as used in the t2p desktop site
 *
 * @returns {boolean}
 */
export function isValidTextMessage(inputString) {
  const invalidCharacterRegex = /[^0-9A-Z!"$%^?&*=_#/\\()-.'+\u00A3\u0040\u003A\u003B \n\r\s]/gi;
  const containsInvalidCharacters = invalidCharacterRegex.test(inputString);
  return !containsInvalidCharacters;
}



// WEBPACK FOOTER //
// ./src/lib/text/index.js